/** @format */
// Migrated from AngularJS: cancelApplicationModal.service.js
import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { StudentApplication } from 'common-typescript/types';
import { cloneDeep } from 'lodash-es';
import { ModalService } from 'sis-common';
import { AppErrorHandler, StudentApplicationEntityService } from 'sis-components';

export interface CancelApplicationValues {
    application: StudentApplication;
}

@Component({
    selector: 'app-cancel-application-modal',
    templateUrl: './cancelApplicationModal.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class CancelApplicationModalComponent {
    constructor(
        @Inject(ModalService.injectionToken) public values: CancelApplicationValues,
        public activeModal: NgbActiveModal,
        private studentApplicationEntityService: StudentApplicationEntityService,
        private appErrorHandler: AppErrorHandler,
    ) {}

    confirm(): void {
        this.studentApplicationEntityService
            .cancel(this.values.application)
            .pipe(this.appErrorHandler.defaultErrorHandler())
            .subscribe(response => {
                // Mutate the consumer-held reference so the page re-renders the new state.
                // Akita's store.upsert does not propagate to @Input-held references — see
                // ANGULAR_MIGRATION.md "Service Migration".
                //
                // cloneDeep: the page's application is a js-data-cached object (route resolve uses
                // commonStudentApplicationService.findById), while `response` is the Akita store
                // entity. In dev mode Akita freezes store entities, so assigning the frozen nested
                // objects (e.g. metadata) straight in left the js-data cache read-only and the next
                // inject()/deepMixIn threw "Cannot assign to read only property 'revision'". Cloning
                // at the Akita→js-data seam mirrors what JsDataSyncService does.
                Object.assign(this.values.application, cloneDeep(response));
                this.activeModal.close({ cancelled: response.state === 'CANCELLED' });
            });
    }

    dismiss(): void {
        this.activeModal.dismiss();
    }
}
